import React from 'react';

export default function TextAlignControl({
  applyTextAlign,
  selectedIndex,
  currentAlign,
}) {
  return (
    <div className="flex items-center gap-1">
      <span className="text-sm text-gray-600 mr-2">Align</span>
      {['left', 'center', 'right'].map((a) => (
        <button
          key={a}
          type="button"
          onClick={() => {
            applyTextAlign(a);
          }}
          disabled={selectedIndex == null}
          className={`px-2 py-1 border rounded text-sm disabled:opacity-50 snap-center 
        ${
          currentAlign === a
            ? 'bg-gray-100 border-gray-300'
            : 'bg-white hover:bg-gray-50'
        }`}
          title={`Align ${a}`}
        >
          {a === 'left' ? '⟸' : a === 'center' ? '⇔' : '⟹'}
        </button>
      ))}
    </div>
  );
}
